export const PRODUCT_IMAGES = {
  'cal-calcitica-virgem': '/media/CAL-VIRGEM.webp',
  'cal-dolomitica-virgem': '/media/CAL-VIRGEM.webp',
  'cal-calcitica-hidratada': '/media/CAL-HIDRATADA.png',
  'cal-dolomitica-hidratada': '/media/CAL-HIDRATADA.png',
} as const;

export type ProductImageKey = keyof typeof PRODUCT_IMAGES;
